import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import { getAppTitle, getDefaultLanguage } from "./helper";

import Header from "./Header";
import Content from "./Content";
import TitleComponent from "./Title";

import "./App.css";

function App() {
  const { pathname } = window.location;
  const langSelect = pathname.split("/")[1];
  const lang = getDefaultLanguage(langSelect);

  const [stateLang, setStateLang] = useState(lang);

  const title = getAppTitle(stateLang);

  return (
    <Router>
      <TitleComponent title={title} />
      <Header lang={stateLang} setStateLang={setStateLang} />
      <div className="container-app">
        <Content lang={stateLang} />
      </div>
      <footer>© {new Date().getFullYear()} Deloitte Direct</footer>
    </Router>
  );
}

export default App;
